'use client';

import { useMediaQuery } from 'hooks/media/useMediaQuery';

/** SSR-safe: starts `false` and corrects after mount so hydration matches. */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)');
}
